import {
  getlearningtypeList,
  getschoolList,
  getgradelist,
  getSubjectlist,
  getTextbooklist,
  getRegionTree
} from '@/api/home'
import { stripStreetLevel, unwrapRegionTree } from '@/utils/regionTree'

/** 与 request 拦截器一致：成功为 code 1 或 "1" */
function unwrapArray (res) {
  if (!res || res.code != 1) return []
  const d = res.data
  if (Array.isArray(d)) return d
  if (d && Array.isArray(d.data)) return d.data
  if (d && Array.isArray(d.list)) return d.list
  return []
}

function normalizeOptions (list) {
  return list.map((item) => ({
    aid: item.aid != null ? item.aid : item.id,
    name: item.name != null ? item.name : (item.title || '')
  })).filter((x) => x.aid != null && x.aid !== '')
}

const state = {
  learningTypeList: [],
  schoolList: [],
  gradeList: [],
  subjectList: [],
  textbookList: [],
  loaded: false,
  loading: false,
  regionTree: [],
  regionTreeLoaded: false,
  regionTreeLoading: false
}

const mutations = {
  SET_LEARNING_TYPE_LIST (state, list) {
    state.learningTypeList = list
  },
  SET_SCHOOL_LIST (state, list) {
    state.schoolList = list
  },
  SET_GRADE_LIST (state, list) {
    state.gradeList = list
  },
  SET_SUBJECT_LIST (state, list) {
    state.subjectList = list
  },
  SET_TEXTBOOK_LIST (state, list) {
    state.textbookList = list
  },
  SET_LOADED (state, v) {
    state.loaded = v
  },
  SET_LOADING (state, v) {
    state.loading = v
  },
  SET_REGION_TREE (state, list) {
    state.regionTree = Array.isArray(list) ? list : []
  },
  SET_REGION_TREE_LOADED (state, v) {
    state.regionTreeLoaded = !!v
  },
  SET_REGION_TREE_LOADING (state, v) {
    state.regionTreeLoading = !!v
  }
}

const actions = {
  async fetchCommonOptions ({ commit, state }) {
    if (state.loading) return
    commit('SET_LOADING', true)
    try {
      const [lr, sr, gr, subj, tb] = await Promise.all([
        getlearningtypeList({}),
        getschoolList({}),
        getgradelist({}),
        getSubjectlist({}),
        getTextbooklist({})
      ])
      commit('SET_LEARNING_TYPE_LIST', normalizeOptions(unwrapArray(lr)))
      commit('SET_SCHOOL_LIST', normalizeOptions(unwrapArray(sr)))
      commit('SET_GRADE_LIST', normalizeOptions(unwrapArray(gr)))
      commit('SET_SUBJECT_LIST', normalizeOptions(unwrapArray(subj)))
      commit('SET_TEXTBOOK_LIST', normalizeOptions(unwrapArray(tb)))
      commit('SET_LOADED', true)
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async ensureCommonOptions ({ state, dispatch }) {
    if (state.loaded) return
    await dispatch('fetchCommonOptions')
  },
  /** 学校增删改后刷新下拉（与 fetchCommonOptions 中学校列表来源一致：getschoolList） */
  async refreshSchoolList ({ commit }) {
    try {
      const sr = await getschoolList({})
      commit('SET_SCHOOL_LIST', normalizeOptions(unwrapArray(sr)))
    } catch (e) {
      /* 忽略，保留旧列表 */
    }
  },
  /** 应用启动时调用一次即可；进入学员页不再重复请求 */
  async fetchRegionTree ({ commit, state }) {
    if (state.regionTreeLoading || state.regionTreeLoaded) return
    commit('SET_REGION_TREE_LOADING', true)
    try {
      const res = await getRegionTree({})
      const raw = unwrapRegionTree(res)
      const tree = stripStreetLevel(raw)
      commit('SET_REGION_TREE', tree.length ? tree : [])
      commit('SET_REGION_TREE_LOADED', true)
    } catch (e) {
      commit('SET_REGION_TREE', [])
      commit('SET_REGION_TREE_LOADED', true)
    } finally {
      commit('SET_REGION_TREE_LOADING', false)
    }
  },
  async ensureRegionTree ({ state, dispatch }) {
    if (state.regionTreeLoaded) return
    await dispatch('fetchRegionTree')
  }
}

const getters = {
  learningTypeList: (s) => s.learningTypeList,
  schoolList: (s) => s.schoolList,
  gradeList: (s) => s.gradeList,
  subjectList: (s) => s.subjectList,
  textbookList: (s) => s.textbookList
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
